import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const LandOwnerPercentage = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      placeholder="Enter land owner percentage"
      control={Input}
      type="text"
      id="ownerPercentage"
      name="ownerPercentage"
      label="Land Owner Percentage"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default LandOwnerPercentage;
